"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var state = {
    open: false,
    mobileMenuOpen: false,
    activeMenuItem: {
        linkNode: null,
        subMenuNode: null
    }
};
exports.default = state;
